import { render } from "./AuthenticationView.vue?vue&type=template&id=4ec6600f&scoped=true"
import script from "./AuthenticationView.vue?vue&type=script&lang=js"
export * from "./AuthenticationView.vue?vue&type=script&lang=js"

import "./AuthenticationView.vue?vue&type=style&index=0&id=4ec6600f&scoped=true&lang=css"

import exportComponent from "/Users/pierre_josselin/Documents/GitHub/ouranos-ws-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec6600f"]])

export default __exports__